/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Dashboard_Percent_Of_TotalInputs */



/**
* | output |
* | --- |
* | "{percent}% of total" |
*
* @param {Dashboard_Percent_Of_TotalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_percent_of_total = /** @type {((inputs: Dashboard_Percent_Of_TotalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Percent_Of_TotalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.percent}% von insgesamt`)
	return /** @type {LocalizedString} */ (`${i?.percent}% of total`)
});